(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mall-fe-vss-signup"] = factory();
	else
		root["mall-fe-vss-signup"] = factory();
})(window, function() {
return 